<template>
    <div>
        <div class="description black"> <p>For video file specs and instructions, <a href="https://www.emmys.com/nominee-specs" target="_blank"><strong>click here</strong></a>. Do not upload closed caption files here; add them within the nominated entry after you attach the video.</p></div>
        <div class="col-12 text-center">
            <dropzone-s3 :bucket_name="bucket_name" v-on:uploadsuccess="addToVideosList" :token="token" :submitterid="submitterid"> </dropzone-s3>
        </div>

        <div v-if="token == 'false'" class="col-12 pt-4 pb-4">
            <video-file-request></video-file-request>
        </div>

        <modal v-if="modalTriggerConfirmDelete" @close="modalTriggerConfirmDelete = false">
            <h3 slot="header">Delete Video</h3>
            <div class="content" slot="body">
                Are you sure you want to delete
                {{videoModalDelete.filename ? videoModalDelete.filename : 'this video'}}?
                It will permanently remove it from your video files list and unlink the
                video from any nominated submissions.
            </div>
            <div class="form-group-submit clearfix" slot="footer">
                <button class="btn btn-cancel btn-transparent pull-left" @click="modalTriggerConfirmDelete = false">Close</button>
                <button class="pull-right" @click="deleteVideo(videoModalDelete.id)">Yes, Delete</button>
            </div>
        </modal>

        <div class="col-12 mt-5" >
            <h2>Video Files</h2>
            <div class="description" v-if="token == 'false'"><p>After video files are uploaded, go to My Nominations to assign them to nominees.</p></div>
            <div class="description" v-show="videoWithAudio.length == 0">No video files have been uploaded</div>
            <table id="admin-entries" class="video-nominee-table" v-show="videoWithAudio.length > 0">
                <thead>
                    <th class="pointer font-size-9 width-400" @click="setSort('filename')">
                        Video File Name
                        <i :class="(sort == 'filename' && order == 'desc') ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                    </th>
                    <th class="pointer width-150 font-size-9" @click="setSort('created_at')">
                        Date Uploaded
                        <i :class="(sort == 'created_at' && order == 'desc') ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                    </th>
                    <th class="pointer font-size-9 width-160" @click="setSort('status')">
                        Video File Status
                        <i :class="(sort == 'status' && order == 'desc') ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                    </th>
                    <th class="font-size-9" v-if="token == 'false'">
                        Entries
                    </th>
                    <th class="font-size-9 width-160">
                        Closed Caption
                    </th>
                    <th class="font-size-9 width-70">
                        Actions
                    </th>
                </thead>
                <tbody>
                    <tr v-for="(video, index) in sortedVideoWithAudio" :class="(index%2) ? 'odd' : 'even'">
                        <td class="pl-2">
                            <div>
                                {{ video.filename }}
                            </div>
                        </td>
                        <td><div>
                            {{ video.created_display }}
                        </div></td>
                        <td><div class="video-upload-status" :class="video.status">
                            {{ statusDisplay(video.status) }}
                        </div></td>
                        <td v-if="token == 'false'">
                            <div>
                                <div v-for="entry in video.entry">
                                    <a :href="`/entry/`+entry.id">{{entry.id}} - {{ entry.program_title }}</a>
                                </div>
                            </div>
                        </td>
                        <td>
                            <closed-caption-table-upload :key="video.id" :videoData="video" :indexVal="index"></closed-caption-table-upload>
                        </td>
                        <td>
                            <div @click.prevent="activateDeleteVideoPopup(video, index)" class="justify-content-center">
                                <i class="fa fa-trash deleteVideo"></i>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>
    import modal from './Modal.vue';
    import dropzone_s3 from './DropZoneS3Multi.vue';
    import ClosedCaptionTableUpload from "./ClosedCaptionTableUpload.vue";
    import axios from "axios";
    export default {
        components: {ClosedCaptionTableUpload, modal, dropzone_s3},
        props: {
            bucket_name: String,
            videos: Array,
            token: {
                type: String,
                default: "false"
            },
            submitterid: String
        },
        data() {
            return {
                videoobject: this.videos,
                videoWithAudio: this.videos,
                sort: '',
                order: '',
                videoModalDelete: null,
                modalTriggerConfirmCCRemove: false,
                activeVideoIndex: 0,
                modalTriggerConfirmDelete: false,
                keepAlive: null,
            }
        },
        computed: {
            sortedVideoWithAudio: function() {
                let app = this;
                if(app.sort) {
                    if(app.order == 'asc') {
                        return app.videoWithAudio.sort((a, b) => a[app.sort].localeCompare(b[app.sort]))
                    } else {
                        return app.videoWithAudio.sort((a, b) => b[app.sort].localeCompare(a[app.sort]))
                    }
                } else {
                    return app.videoWithAudio;
                }
            }
        },
        mounted() {
            // send a keep-alive request every 5 minutes, to ensure the session / CSRF token doesn't expire
            this.keepAlive = setInterval(() => this.sendKeepAlive(), 300000);
        },
        methods: {
            setSort: function(value) {
              let app = this;
              if (app.order === 'asc') {
                  app.order = 'desc';
              } else {
                  app.order = 'asc';
              }
              app.sort = value;
            },
            addToVideosList: function(value) {
                // Add it to the 'no audio' array
                let app = this;
                let exists = false;
                app.videoWithAudio.forEach(function(video){
                    if (video.id == value.id) {
                        exists = true;
                    }
                });
                if (!exists) {
                    app.videoWithAudio.unshift(value)
                }
            },
            statusDisplay(inputStatus) {
                switch (inputStatus) {
                    case 'Upload Failed':
                        return 'Upload Failed';
                    case 'Uploading':
                        return 'Uploading...';
                    case 'Need More Info':
                        return 'Needs More Information';
                    case 'Canceled':
                        return 'Canceled';
                    case 'Video Approved':
                        return 'Video Approved';
                    case 'Processing Failed':
                        return 'Under Review';
                    default:
                        return 'Under Review';
                }
            },
            activateDeleteVideoPopup(video, index) {
                let app = this;
                app.modalTriggerConfirmDelete = true;
                app.videoModalDelete = video;
                app.activeVideoIndex = index;
                console.log(app.activeVideoIndex)
            },
            deleteVideo: function(videoId) {
                let app = this;
                if (!videoId) {
                    app.videoWithAudio.splice(app.activeVideoIndex, 1);
                    app.modalTriggerConfirmDelete = false;
                    app.activeVideoIndex = Math.max(app.activeVideoIndex - 1, 0);
                    return;
                }

                let actionUrl = '/video/'+videoId;
                axios(
                    {
                        method: 'DELETE',
                        data: {
                            'token': false,
                        },
                        url: actionUrl,
                    }).then(function() {
                        app.modalTriggerConfirmDelete = false;
                        app.videoWithAudio.splice(app.activeVideoIndex, 1);
                        window.location.reload();
                    }).catch(function (error) {
                        // handle error
                        console.log('This is the error returned', error);
                    });
            },

            sendKeepAlive() {
                axios.post('/keep-alive')
                    .catch(function (error) {
                        if (error.response.status === 401) {
                            // TODO we could show a login modal here?
                        }
                    });
            },
        },

        beforeDestroy() {
            clearInterval(this.keepAlive);
        },
    }
</script>
